module.exports = __webpack_public_path__ + "img/add_item.ce84870e.png";